const MAP = [
  [/math/i, "bg-sky-100 text-sky-800 border-sky-200", "#5F7AB5"],
  [/english/i, "bg-pink-100 text-pink-800 border-pink-200", "#EC4899"],
  [/biology/i, "bg-emerald-100 text-emerald-800 border-emerald-200", "#10B981"],
  [/chem/i, "bg-green-100 text-green-800 border-green-200", "#22C55E"],
  [/physics/i, "bg-indigo-100 text-indigo-800 border-indigo-200", "#6366F1"],
  [/science/i, "bg-lime-100 text-lime-800 border-lime-200", "#84CC16"],
  [/history/i, "bg-gold-100 text-gold-800 border-gold-200", "#C9971C"],
  [/geog/i, "bg-lime-100 text-lime-800 border-lime-200", "#65A30D"],
  [/french/i, "bg-violet-100 text-violet-800 border-violet-200", "#8B5CF6"],
  [/spanish/i, "bg-yellow-100 text-yellow-800 border-yellow-200", "#EAB308"],
  [/welsh/i, "bg-red-100 text-red-800 border-red-200", "#EF4444"],
  [/latin/i, "bg-stone-100 text-stone-800 border-stone-200", "#A8A29E"],
  [/art/i, "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-200", "#D946EF"],
  [/religious|^re$|rs/i, "bg-purple-100 text-purple-800 border-purple-200", "#A855F7"],
  [/comput/i, "bg-cyan-100 text-cyan-800 border-cyan-200", "#06B6D4"],
  [/music/i, "bg-rose-100 text-rose-800 border-rose-200", "#F43F5E"],
  [/design|dt/i, "bg-amber-100 text-amber-800 border-amber-200", "#E3C35A"],
];
const DEFAULT = ["bg-slate-100 text-slate-700 border-slate-300", "#8A8A8A"];

export const subjectStyle = (s) => {
  const m = MAP.find(([re]) => re.test(s || ""));
  return m ? { chip: m[1], dot: m[2] } : { chip: DEFAULT[0], dot: DEFAULT[1] };
};

export const ukToday = () => new Date().toLocaleDateString("en-CA", { timeZone: "Europe/London" });
export const plusDays = (n) => { const d = new Date(`${ukToday()}T12:00:00`); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
export const addDays = (iso, n) => { const d = new Date(`${iso}T12:00:00`); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
export const nextWeekday = (wd) => { for (let i = 1; i <= 7; i += 1) { const d = plusDays(i); if (new Date(`${d}T12:00:00`).getDay() === wd) return d; } return plusDays(1); };
export const fmtDue = (d) => new Date(`${d}T12:00:00`).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
export const daysUntil = (d) => Math.round((new Date(`${d}T12:00:00`) - new Date(`${ukToday()}T12:00:00`)) / 86400000);
